module.exports = __webpack_public_path__ + "static/media/cursed_weapons.083ca590.png";